import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const getBookings = async (type: 'user' | 'operator') => {
  const searchParams = new URLSearchParams({ type });
  return await apiClient.get(
    `${ENDPOINTS.BOOKINGS}?${searchParams.toString()}`,
  );
};
